import React, { useState, useEffect } from 'react';
import { InputSwitch } from 'primereact/inputswitch';

const LIGHT_THEME = 'saga-green';
const DARK_THEME = 'lara-dark-blue';

// const themes: Theme[] = [
//   { label: 'Saga Green', value: 'saga-green' },
//   { label: 'Lara Dark Blue', value: 'lara-dark-blue' },
//   { label: 'Bootstrap 4 Dark Purple', value: 'bootstrap4-dark-purple' },
//   { label: 'Lara light pink', value: 'lara-light-pink' },
//   { label: 'Lara light green', value: 'lara-light-green' },
//   { label: 'Mdc dark indigo', value: 'mdc-dark-indigo' },
//   { label: 'Vela orange', value: 'vela-orange' },
// ];

export const ThemeSelect = () => {
  const [isDark, setIsDark] = useState<boolean>(false);

  useEffect(() => {
    const linkElement = document.getElementById(
      'theme-link',
    ) as HTMLLinkElement;

    if (linkElement) {
      linkElement.href = `/themes/${isDark ? DARK_THEME : LIGHT_THEME
        }/theme.css`;
    }
  }, [isDark]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <i className="pi pi-sun" />
      <InputSwitch checked={isDark} onChange={(e) => setIsDark(e.value)} />
      <i className="pi pi-moon" />
    </div>
  );
};

export default ThemeSelect;
